import React, { useEffect } from "react"
import IconClose from "../images/close.inline.svg"
import ReactModal from "react-modal"

ReactModal.setAppElement("#___gatsby")

function Modal({
  isOpen,
  closeModal,
  buttonRef,
  overlayClassName,
  className,
  id,
  children,
}) {
  const neutralizeBack = (callback) => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      window.history.pushState(null, "", window.location.href);
      callback();
    };
  };

  const revivalBack = () => {
    // Return focus to the button that opened the modal
    buttonRef?.current && buttonRef.current.focus();
    window.onpopstate = undefined;
    // Restore the previous URL
    window.history.back();
  };

  // Listen for the escape key and close the overlay if it's open
  useEffect(() => {
    const handleEsc = ({keyCode}) => {
      if (keyCode === 27) {
        closeModal()
      }
    }
    window.addEventListener("keyup", handleEsc)

    return () => {
      window.removeEventListener("keyup", handleEsc)
    }
  }, [])

  return (
    <ReactModal
      id={id}
      isOpen={isOpen}
      overlayClassName={overlayClassName || "overlay"} 
      className={className || "overlay__content"}
      bodyOpenClassName="util__body-lock"
      onAfterOpen={() => {
        neutralizeBack(() => closeModal())
      }}
      onAfterClose={() => {
        revivalBack()
      }}
    >
      <button
        className="overlay__button overlay__button--close"
        onClick={() => closeModal()}
        aria-label="Close overlay"
      >
        <IconClose />
      </button>
      {children}
    </ReactModal>
  )
}

export default Modal
